import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M13.675 6.551 9.05 2.218a.92.92 0 0 0-1.1 0L3.325 6.551A.91.91 0 0 0 3 7.25v6.874c0 .504.41.913.917.913h9.166a.914.914 0 0 0 .917-.913V7.25a.91.91 0 0 0-.325-.698ZM8.5 5.814 11 8.157v3.879H6v-3.88l2.5-2.342Z" clip-rule="evenodd"></path><path d="m24.05 2.218 4.625 4.333A.91.91 0 0 1 29 7.25v6.874c0 .504-.41.913-.917.913h-9.166a.914.914 0 0 1-.917-.913V7.25a.91.91 0 0 1 .325-.698l4.625-4.333a.92.92 0 0 1 1.1 0Z"></path><path d="M13.675 21.551 9.05 17.218a.92.92 0 0 0-1.1 0l-4.625 4.333A.91.91 0 0 0 3 22.25v6.874c0 .504.41.913.917.913h9.166a.914.914 0 0 0 .917-.913V22.25a.91.91 0 0 0-.325-.698Z"></path><path d="m24.05 17.218 4.625 4.333a.91.91 0 0 1 .325.698v6.874c0 .504-.41.913-.917.913h-9.166a.914.914 0 0 1-.917-.913V22.25a.91.91 0 0 1 .325-.698l4.625-4.333a.92.92 0 0 1 1.1 0Z"></path></g>';
export var HomeSimilarSVG = function HomeSimilarSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
HomeSimilarSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(HomeSimilarSVG);